import { useQuery } from "react-query";
import { getClaimsToRole } from "../services/user/getClaimsToRole";

export const useGetRoleClaims = (roleId: string, options:any) => useQuery([("roleClaims"), roleId], ()=> getClaimsToRole(roleId), options)